export default __webpack_public_path__ + "static/media/image-1.e365dd87.svg";